import MaskedInput from 'react-text-mask'
import React, { ChangeEvent, FocusEvent, FC } from 'react'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

interface Props {
  name: string
  value: string
  title?: string
  placeholder?: string
  onChange: (event: ChangeEvent<HTMLInputElement>) => {}
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void
}

const currencyMask = createNumberMask({
  prefix: '',
  suffix: '',
  inputMode: 'numeric',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ',',
  allowDecimal: true,
  decimalSymbol: '.',
  decimalLimit: 2, // how many digits allowed after the decimal
  integerLimit: 9, // limit length of integer numbers
  allowNegative: false,
  allowLeadingZeroes: false,
})

const stripChars = (str) => str.replace(/[^\d.]/gi, '')
const fixDecimals = (val) => (Math.round(Number(val) * 100) / 100).toFixed(2)

const fixInt = (val) => Math.round(Number(val) * 100) / 100

const CurrencyInput: FC<Props> = ({
  name,
  value,
  placeholder,
  onChange,
  onBlur = (e) => {},
  ...rest
}) => {
  const [localCurrencyValue, setLocalCurrencyValue] = React.useState<
    string | undefined
  >(value)

  const handleCurrencyChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      // leave local variable alone while editing
      setLocalCurrencyValue(e.target.value)
      const stripped = stripChars(e.target.value)
      const value = fixInt(stripped)
      const newEvent: React.ChangeEvent<HTMLInputElement> = {
        ...e,
        target: {
          ...e.target,
          name,
          // @ts-ignore - commits number as an answer instead of string for loanAmount, ltv calculations
          value,
        },
      }
      onChange(newEvent)
    },
    []
  )

  // change local variable once user is finished editing
  const handleBlur = React.useCallback((e) => {
    const stripped = stripChars(e.target.value)
    const newValue = fixDecimals(stripped)
    setLocalCurrencyValue(newValue)

    onBlur(e)
  }, [])

  return (
    <div className="input__currency-wrapper">
      <span className="input__currency-indicator">$</span>
      <MaskedInput
        mask={currencyMask}
        type="text"
        value={localCurrencyValue}
        autoComplete={'off'}
        name={name}
        className="input__field --currency"
        onChange={handleCurrencyChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        {...rest}
      />
    </div>
  )
}

export default CurrencyInput
